module.exports = __webpack_public_path__ + "static/img/Rectangle 4.3faf24f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Rectangle 4.png
// module id = JIWl
// module chunks = 1